export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4212 2.99998C14.9349 2.99998 16.1721 4.24889 16.2586 5.82369L16.2634 5.99996V17.1386H14.3686V5.99996C14.3686 5.48713 14.0029 5.06446 13.5317 5.0067L13.4212 4.99997H5.84216C5.3563 4.99997 4.95587 5.38601 4.90114 5.88334L4.89477 5.99996V17.9999C4.89477 18.5127 5.2605 18.9354 5.73167 18.9932L5.84216 18.9999H17.8433V20.9999H5.84216C4.32854 20.9999 3.09127 19.751 3.00482 18.1762L3 17.9999V5.99996C3 4.40229 4.18321 3.09632 5.67516 3.00508L5.84216 2.99998H13.4212Z"
      fill="currentColor"
    />
    <path
      d="M11.526 8.49997C12.0492 8.49997 12.4734 8.94768 12.4734 9.49996C12.4734 10.0128 12.1076 10.4355 11.6365 10.4932L11.526 10.5H7.73645C7.21322 10.5 6.78906 10.0522 6.78906 9.49996C6.78906 8.98713 7.15479 8.56446 7.62596 8.50669L7.73645 8.49997H11.526Z"
      fill="currentColor"
    />
    <path
      d="M11.526 12.4998C12.0492 12.4998 12.4734 12.9475 12.4734 13.4998C12.4734 14.0126 12.1076 14.4353 11.6365 14.4931L11.526 14.4998H7.73645C7.21322 14.4998 6.78906 14.0521 6.78906 13.4998C6.78906 12.987 7.15479 12.5643 7.62596 12.5065L7.73645 12.4998H11.526Z"
      fill="currentColor"
    />
    <path
      d="M20.0535 13H15.3165C14.7933 13 14.3691 13.4477 14.3691 14V17.5775C14.3691 18.4765 14.7016 19.34 15.2959 19.9842C15.895 20.6336 16.7173 20.9999 17.576 20.9999H17.7579C18.62 20.9999 19.4465 20.6369 20.0541 19.9913C20.6605 19.3471 21.0008 18.4758 21.0008 17.5676V14C21.0008 13.4477 20.5767 13 20.0535 13ZM16.2639 14.9999H19.1061V17.5676C19.1061 17.9476 18.9637 18.3122 18.7099 18.5817C18.458 18.8494 18.1153 18.9999 17.7579 18.9999H17.576C17.2285 18.9999 16.8958 18.8517 16.6534 18.5889L16.5649 18.4832C16.3709 18.2272 16.2639 17.9081 16.2639 17.5775V14.9999Z"
      fill="currentColor"
    />
  </svg>
);
